import Vue from 'vue'
import {
    Container,
    Header,
    Aside,
    Main,
    Footer,

    RadioGroup,
    RadioButton,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,

    Button,
    Select,
    Input,
    Table,
    TableColumn,
    Pagination,

    Carousel,
    CarouselItem,
    Divider,
    Image,

    Tabs,
    TabPane,

    Card,
    Descriptions,
    DescriptionsItem,
    Link,

    Tag,
    // 其他你需要使用的组件
    Message,
    MessageBox
} from 'element-ui'

// 注册组件
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)

Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)

Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Table)

Vue.use(Tag)
Vue.use(TableColumn)
Vue.use(Pagination)

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Divider)
Vue.use(Image)

Vue.use(Tabs)
Vue.use(TabPane)

Vue.use(Card)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Link)

// 注册其他组件...

// 挂载消息提示和消息框（这些不是通过 Vue.use 注册的）
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$prompt = MessageBox.prompt